import { ColDef, ICellRendererParams, ValueGetterParams } from "ag-grid-community";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LoadMessageLogsExport, LoadSecureChatMessageLogsExport, LoadUsers } from "../../../actions";
import { setHeaderCount, setHeaderTitle, setRefreshHandler, setSelectedCount } from "../../../helpers/header.helper";
import setToast from "../../../helpers/toaster.helper";
import { ClearSelectionIcon, DeleteLogsIcon, DownloadLogsIcon, FailDotIcon, InProgressDotIcon, SuccessDotIcon, TollfreeIcon, UnDownloadLogsIcon } from "../../../icon";
import { MessageLogExportModel } from "../../../models/msg.export.model";
import * as selector from "../../../selectors/selectors";
import { UtilityService } from "../../../services/UtilityService";
import { MessageLogSevice } from "../../../services/messageLogService";
import Confirm_Dialog from "../../shared/confirm-dialog.component";
import { ActionLabels, emptyLabels, pageTitles } from "../../shared/constants";
import GridComponent from '../../shared/grid';
import { ExportComponent, messageLogDownLoad } from "../../shared/grid/export-component";
import { TypeRenderer } from "../../shared/grid/typeRendrer";
import PageHeaderComponent from "../../shared/page-header.component";
import { ToasterType } from "../../shared/toaster/toaster.model";
import { SecureChatMessageLogService } from "../../../services/secureChatMessageLogService";

interface BackgroundFileData {
    FileName: string;
    FileKey: string;
}

interface IStateProps {

}

interface IDispatchProps {

}
interface IProps extends IStateProps, IDispatchProps { }

const SecureChatExportMsgLogsComponent = (props: IProps) => {
    const [gridApi, setGridApi] = useState<any>(null);
    const SecureChatExportMessageLogs = useSelector(selector.SecureChatExportMessageLogs)
    const Users = useSelector(selector.users)
    const [columnApi, setColumnApi] = useState<any>(null);
    const [messageLogs, setMessageLogs] = useState<MessageLogExportModel[]>(SecureChatExportMessageLogs);
    const [checkedExports, setCheckExports] = useState<MessageLogExportModel[]>([]);
    const [showMultiActionButtons, setShowMultiActionButtons] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isBulkDelete, setIsBulkDelete] = useState<boolean>(false);
    const [showConfirmDialog, setShowConfirmDialog] = useState<boolean>(false);
    const [id, setId] = useState<string>(undefined);
    const dispatch = useDispatch()

    useEffect(() => {
        setMessageLogs(SecureChatExportMessageLogs.filter((log) => log.status !== "InProgress"))
    }, [SecureChatExportMessageLogs])

    useEffect(() => {
        if (Users.length === 0) {
            LoadUsers(dispatch)
        }
        LoadSecureChatMessageLogsExport(dispatch);
    }, [])

    const gridRefresh = () => {
        LoadSecureChatMessageLogsExport(dispatch);
        if (!!columnApi) {
            columnApi.resetColumnState()
        }

        if (!!gridApi) {
            gridApi.refreshCells({ force: true })
        }
    }

    useEffect(() => {
        setHeaderTitle("Secure Chat Export History");
        setHeaderCount(SecureChatExportMessageLogs?.length || 0)
        setRefreshHandler(gridRefresh);
        return setHeaderTitle
    }, [gridApi, columnApi])

    useEffect(() => {
        setHeaderCount(SecureChatExportMessageLogs?.length || 0)
        setSelectedCount(0)
    }, [SecureChatExportMessageLogs])

    const onGridReady = (params) => {
        setGridApi(params.api)
    }

    const onSelectionChanged = () => {
        let CheckedExports: MessageLogExportModel[] = gridApi.getSelectedRows()
        if (gridApi && CheckedExports.length > 0) {
            setShowMultiActionButtons(true);
            setCheckExports(CheckedExports);
            setSelectedCount(CheckedExports.length)
        }
        else {
            setShowMultiActionButtons(false);
            setCheckExports([]);
            setSelectedCount(CheckedExports.length)
        }
    }

    const handleDownload = (Id: string) => {
        SecureChatMessageLogService.downloadMesageLogs(Id).then((res) => {
            const url = URL.createObjectURL(new Blob([res.data], { type: "application/zip" }));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Messagelog.zip");
            link.click();
        }).catch((err) => {
        })
    }


    const ReportsColoumnDefs: ColDef[] = [
        {
            field: "data",
            headerName: "File Name",
            valueGetter: (params: ValueGetterParams) => {
                if (!!params.data.data) {
                    return params.data.data
                }
            },
            cellClass: "c-pointer",
            headerCheckboxSelection: true,
            checkboxSelection: true,
            minWidth: 260,
            width: 260,
        },
        {
            field: "status",
            headerName: "Status",
            autoHeight: true,
            valueGetter: (params: ValueGetterParams) => {
                return params.data.status;
            },
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data.status !== null) {
                    const label = params.data.status === "InProgress" ? "In Progress" : params.data.status;
                    const icon = params.data.status === "Completed" ? SuccessDotIcon : params.data.status === "Fail" ? FailDotIcon : params.data.status === "InProgress" ? InProgressDotIcon : TollfreeIcon;
                    const Type = {
                        component: TypeRenderer,
                        params: {
                            Icon: icon, Label: label, Id: params.data.id
                        }
                    }
                    return Type
                }
            },
            minWidth: 100,
            width: 100,
            maxWidth: 200,
        },
        {
            field: "createdById",
            headerName: "Created by",
            valueGetter: (params: ValueGetterParams) => {
                if (Users) {
                    const user = Users.find((u) => u.ID === params.data.createdById)
                    if (!!user) {
                        let name = user?.PhoneNumber
                        if (user.FirstName) {
                            name = Users.find((u) => u.ID === params.data.createdById)?.FirstName;
                        }
                        if (user.LastName) {
                            name = name + " " + Users.find((u) => u.ID === params.data.createdById)?.LastName
                        }
                        return UtilityService.trimMessage(name, 17);
                    } else {
                        return ""
                    }
                } else {
                    return "No Data"
                }
            },
            cellClass: "c-pointer",
            minWidth: 100,
            width: 100,
            maxWidth: 240,
        },
        {
            field: "createdDateTime",
            headerName: "Created on",
            valueGetter: (params: ValueGetterParams) => {
                return UtilityService.convertToDateTimeFormat(
                    params.data.createdDateTime
                );
            },
            cellClass: "c-pointer",
            minWidth: 100,
            width: 100,
            maxWidth: 200,
        },

        {
            headerName: "Download",
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data.status === "Completed") {
                    if (params.data.data !== null) {

                        const Type = {
                            component: TypeRenderer,
                            params: {
                                Icon: DownloadLogsIcon, Label: "", Id: params.data.id, onClick: () => handleDownload(params.data.id)
                            }
                        }
                        return Type
                    }
                }
                else {
                    const Type = {
                        component: TypeRenderer,
                        params: {
                            Icon: UnDownloadLogsIcon, Label: "", Id: params.data.id, onClick: () => { setToast("Please wait to export the log completely", ToasterType.DANGER) }
                        }
                    }
                    return Type
                }
            },
            cellClass: "c-pointer justify-center",
            minWidth: 100,
            width: 100,
            maxWidth: 100,
        },
        {
            headerName: "Delete",
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data.id !== null) {
                    const Type = {
                        component: TypeRenderer,
                        params: {
                            Icon: DeleteLogsIcon, Label: "", Id: params.data.id, onClick: () => openDeleteConfirmDialog(params.data.id, false)
                        }
                    }
                    return Type
                }
            },
            cellClass: "c-pointer justify-center",
            minWidth: 100,
            width: 100,
            maxWidth: 100,
        },
    ]

    const searchReport = (e: any) => {
        gridApi.setQuickFilter(e.target.value);
    }

    const openDeleteConfirmDialog = (Id?: string, isBulk?: boolean) => {
        setIsBulkDelete(isBulk)
        setIsLoading(false);
        setShowConfirmDialog(true);
        setId(Id)
    }

    const closeDeleteConfirmDialog = () => {
        setIsLoading(false);
        setShowConfirmDialog(false);
        setId(undefined);
    }

    const handleConfirmDialogClose = (isConfirm: boolean) => {
        if (isConfirm) {
            let ids = []
            if (isBulkDelete) {
                checkedExports.forEach((e) => {
                    ids.push(e.id);
                })
            } else {
                ids.push(id)
            }
            setIsLoading(true);
            SecureChatMessageLogService.deleteMessagelogexporthistory({ Ids: ids }).then((res) => {
                setToast(`Message logs deleted.`, ToasterType.SUCCESS)
                clearSelection();
                LoadSecureChatMessageLogsExport(dispatch);
                closeDeleteConfirmDialog();
            }).catch((err) => {
                setToast(`Message logs delete fail.`, ToasterType.DANGER)
                closeDeleteConfirmDialog();
            })
        }
        else {
            closeDeleteConfirmDialog();
        }
    }

    const clearSelection = () => {
        if (!!gridApi && !!checkedExports?.length) {
            gridApi.deselectAll();
        }
        setCheckExports([])
    }

    const multipleDownload = () => {
        setToast(`Message logs download started.`, ToasterType.INFO)
        if (checkedExports.length > 0) {
            const downloadPromises = checkedExports.map((e) => {
                if (e.status === "Completed") {
                    return handleDownload(e.id)
                }
            }).filter(promise => promise != null || undefined);
            Promise.all(downloadPromises)
                .then(() => {
                    setToast(`All message logs downloaded successfully. You can check them!`, ToasterType.SUCCESS);
                })
                .catch(() => {
                    setToast(`Some message logs failed to download.`, ToasterType.DANGER);
                });
        }
        clearSelection();
    }

    const checkBtnValidity = (): boolean => {
        if (checkedExports.length > 0) {
            return checkedExports?.filter((logs => logs.status !== "Completed")).length === checkedExports?.length
        } else {
            return false
        }
    }

    return (
        <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
            {showConfirmDialog && <Confirm_Dialog
                onClose={handleConfirmDialogClose}
                Show={showConfirmDialog}
                Text={"This will permanently delete the file. Do you wish to proceed?"}
                ButtonName={"Confirm"}
                Loading={isLoading}
                IsMobileDevice={false}
                Title="Delete this file?"
            />}

            <div>
                <PageHeaderComponent
                    onSearch={searchReport}
                    GridTitle={""}
                    Count={SecureChatExportMessageLogs.length}
                    PlaceHolder={"Find a File..."}
                    ShowFilterIcon={false}
                    ShowMultiActionButtons={showMultiActionButtons}
                    MultiActionButtons={[
                        {
                            Name: ActionLabels.DOWNLOAD,
                            Variant: "primary",
                            Hide: checkBtnValidity(),
                            ClassName: "mr-1",
                            OnClick: () => multipleDownload()
                        },
                        {
                            Name: ActionLabels.DELETE,
                            Variant: !!checkedExports?.length ? "primary" : "disabled",
                            ClassName: "mr-1",
                            OnClick: () => openDeleteConfirmDialog("", true)
                        },
                        {
                            Name: ActionLabels.CLEAR_SELECTION,
                            Variant: "text",
                            ClassName: "p-0 mr-1 w-space",
                            Icon: ClearSelectionIcon,
                            OnClick: () => clearSelection(),
                        }
                    ]}
                />
                {<div className="report-text color-conv-section-inactive my-1 px-3">
                    <div>This table shows all exports initiated in the past 14 days. A download link will appear once your export is ready. Use the refresh option to view the latest status.</div>
                    <div><span>Note: </span><span className="h6-semibold">Exports older than 14 days are automatically deleted.</span></div>
                </div>}
            </div>
            <GridComponent
                ColumnDefs={ReportsColoumnDefs}
                OnSelectionChanged={onSelectionChanged}
                RowData={messageLogs}
                OnGridReady={onGridReady}
                IsPaginationEnabled={true}
                EmptyLabel={emptyLabels.REPORTS}
                LockVisible={false}
                IsFilterPresent={false}
                gridApi={gridApi}
            />
        </div>
    )
}

export default SecureChatExportMsgLogsComponent;
